import http from '@/utils/http';

const baseUrl = '/rastreabilidade/visao-geral';

export default {
    pesquisar(filtro) {
        return http.get({
            url: baseUrl + `/buscar?filtro=${filtro}`,
            lockScreen: false
        });
    },

    buscarTotalizadoresVisaoGeral(filtro) {
        let url = baseUrl + '/totalizadores?codigoFazenda=' + filtro.textoBusca +
                            '&data-inicio=' + filtro.dataInicioPesquisa +
                            '&data-fim=' + filtro.dataFimPesquisa +
                            '&fazendasCertificadas=' + filtro.fazendasCertificadas;
        return http.get({
            url: url,
            lockScreen: false
        });
    },

    buscarTerritoriosGeometriaFazenda(filtro) {
        let url = baseUrl + '/buscar-territorios?codigoFazenda=' + filtro.textoBusca +
                            '&data-inicio=' + filtro.dataInicioPesquisa +
                            '&data-fim=' + filtro.dataFimPesquisa +
                            '&fazendasCertificadas=' + filtro.fazendasCertificadas;
        return http.get({
            url: url,
            lockScreen: true
        });
    }

};
